import React, { cloneElement, Fragment, isValidElement } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { CriteriaFieldDropDownWrapper } from 'Components/frameworks/drop-down-simplified/CriteriaFieldDropDownWrapper';
import { Icon } from 'Components/frameworks/icon/Icon';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
type Props = {
  children: React.ReactNode;
  className?: string;
  disableValidateButton?: boolean;
  toggleEditCriteria?: (isExpanded: boolean) => void;
  updateCriteria?: () => void;
  cancelEditCriteria?: () => void;
  trackCriteriaClick: () => void;
  triggerComponent: React.ReactNode;
  openByDefault?: boolean;
  dataTestId?: string;
};
export const EditMyCriteriaFieldWrapper = ({
  children,
  className,
  disableValidateButton,
  toggleEditCriteria,
  updateCriteria,
  trackCriteriaClick,
  cancelEditCriteria,
  triggerComponent,
  openByDefault,
  dataTestId = '',
}: Props) => {
  const { isTablet } = useResponsive();
  const isMobile = !isTablet;
  return (
    <CriteriaFieldDropDownWrapper
      cancelEditCriteria={cancelEditCriteria}
      toggleEditCriteria={toggleEditCriteria}
      openByDefault={openByDefault}
      renderCriteriaButton={(toggleButtonCriteriaExpansion, isCriteriaExpanded) => (
        <button
          aria-expanded={isCriteriaExpanded}
          className={classnames('flex h-full items-stretch gap-5', className)}
          onClick={() => {
            trackCriteriaClick();
            // toggle local state
            toggleButtonCriteriaExpansion();
          }}
          type="button"
        >
          {triggerComponent}
          <Icon
            className="self-center"
            name={ICONS.ARROW_DOWN}
            rotation={isCriteriaExpanded ? 180 : 0}
            width="1em"
          />
        </button>
      )}
      title={t('booking.editCriteria.buttonLabel')}
      dataTestId={dataTestId}
    >
      {(toggleCriteriaExpansion) => (
        <Fragment>
          {React.Children.map(children, (child) => {
            if (!isValidElement(child) || typeof child.type === 'string') {
              return child;
            }

            return cloneElement(child, {
              toggleCriteriaExpansion,
            });
          })}

          <div
            className={classnames({
              'fixed bottom-0 mt-auto flex w-full justify-center border-t-1 bg-white p-15 shadow':
                isMobile,
              'my-20 text-center': !isMobile,
            })}
          >
            <Button
              data-selector="EditMyCriteriaDropDown-apply"
              data-testid="criteria-validation-button"
              isDisabled={disableValidateButton}
              onClick={() => {
                // toggle criteria
                toggleCriteriaExpansion();
                // update criteria value in EditMyCriteria
                updateCriteria && updateCriteria();
              }}
            >
              {t('booking.editCriteria.validateCriteria')}
            </Button>
          </div>
        </Fragment>
      )}
    </CriteriaFieldDropDownWrapper>
  );
};
